"use strict";
document.addEventListener('DOMContentLoaded', function () {
    const wrappers = document.querySelectorAll('.card-block-scroll-wrapper, .compact-card-list-scroll-wrapper');
    wrappers.forEach(wrapper => {
        const row = wrapper.querySelector('.card-block-row, .compact-card-list-row');
        if (!row)
            return;
        let animationFrameId = null;
        function updateMask() {
            const scrollLeft = row.scrollLeft;
            const maxScroll = row.scrollWidth - row.clientWidth;
            wrapper.classList.remove('mask-left', 'mask-right', 'mask-both');
            if (scrollLeft <= 0) {
                wrapper.classList.add('mask-right');
            }
            else if (scrollLeft >= maxScroll - 1) {
                wrapper.classList.add('mask-left');
            }
            else {
                wrapper.classList.add('mask-both');
            }
        }
        function handleScroll() {
            if (animationFrameId !== null) {
                cancelAnimationFrame(animationFrameId);
            }
            animationFrameId = requestAnimationFrame(() => {
                updateMask();
                animationFrameId = null;
            });
        }
        row.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', updateMask);
        updateMask();
    });
});
